import { type Message } from "@/lib/askAiUtils";
import { TrendingUp, Clock, Target, Shield } from "lucide-react";

interface ProcessingInfoProps {
  message: Message;
}

export function ProcessingInfo({ message }: ProcessingInfoProps) {
  if (message.type !== 'ai' || (!message.totalCandidatesFound && !message.processingTime)) {
    return null;
  }

  return (
    <div className="mt-3 pt-3 border-t border-gray-200">
      <div className="flex flex-wrap gap-4 text-xs text-gray-500 space-grotesk">
        {message.totalCandidatesFound && (
          <div className="flex items-center gap-1">
            <TrendingUp className="h-3 w-3" />
            Found: {message.totalCandidatesFound} candidates
          </div>
        )}
        {message.queryIntent && (
          <div className="flex items-center gap-1">
            <Target className="h-3 w-3" />
            Intent: {message.queryIntent}
          </div>
        )}
      </div>
    </div>
  );
}
